export default __webpack_public_path__ + "static/media/minikeys.ef36a45f.svg";